import { WhyBlocked } from "@/components/BlockedPanel";

export const PLANT_SOURCES = { file: "From file", po_lookup: "PO lookup", vendor_material: "Vendor+material default", vendor: "Vendor default", none: "No plant" };

export function PoPlant({ r, testid }) {
  const src = r.plant_source || (r.plant ? "file" : "none");
  if (src === "none" || !r.plant) {
    return (
      <span className="inline-flex items-center" data-testid={testid}>
        <span className="rounded-full border border-amber-200 bg-amber-50 px-1.5 py-0.5 text-[10px] font-medium text-amber-800">No plant</span>
        {r.id && <WhyBlocked kind="po" id={r.id} testid={`${testid}-why`} />}
      </span>
    );
  }
  return (
    <span data-testid={testid}>
      <span className="font-mono font-semibold">{r.plant}</span>
      <span className={`ml-1 rounded px-1 text-[10px] ${src === "file" ? "bg-slate-100 text-slate-600" : "bg-sky-50 text-sky-700"}`}>{PLANT_SOURCES[src] || src}</span>
    </span>
  );
}
